const artistsES = {
    "view": {
        "table": {
            "title": "Tu lista de artistas",
            "column": {
                "name": "Nombre del Artista",
                "owner": "Propietario",
                "spotify_link": "Enlace de Spotify",
                "apple_music_link": "Enlace de Apple Music",
                "amazon_music_link": "Enlace de Amazon Music",
                "deezer_link": "Enlace de Deezer",
                "flagged": "Marcado",
                "blacklisted": "Listado Negativo",
                "action": "Acción"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "message": {
                "artistFlagged": "Este artista está marcado y se requiere un pago en depósito para distribuir el lanzamiento en Spotify.",
                "artistNotFlagged": "Este artista es elegible para la distribución en Spotify.",
                "artistBlacklisted": "Este artista está en la lista negra y no es elegible para la distribución.",
                "artistNotBlacklisted": "Este artista no está en la lista negra y es elegible para la distribución.",
            }
        },
        "message": {
            "success": "¡El artista ha sido eliminado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "notSubscribed": "No estás suscrito a ningún plan, por lo tanto, solo puedes agregar <strong>3 Artistas</strong>. Por favor, <3>suscríbete</3> a un plan para disponer de una cantidad ilimitada de artistas.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para disponer de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para disponer de esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "El artista {{artistName}} no puede ser eliminado",
                "body": "El artista {{artistName}} no puede ser eliminado ya que ya tiene Pista(s)/Lanzamiento(s) asociados con él."
            },
            "delete": {
                "header": "¿Eliminar {{artistName}}?",
                "body": "¿Estás seguro de que realmente deseas eliminar a este artista? Esta acción podría desvincular a tu artista del lanzamiento asignado."
            },
            "edit": {
                "header": "¿Editar {{artistName}}?",
                "body": "¿Estás seguro de que deseas cambiar el nombre de tu artista? Esto podría afectar los metadatos del lanzamiento."
            }
        }
    },
    "add": {
        "title": "Agregar Artista",
        "form": {
            "label": {
                "is_new_artist": "Es Nuevo Artista",
                "spotify_profile": "Perfil de Spotify",
                "deezer_profile": "Perfil de Deezer",
                "amazon_music_profile": "Perfil de Amazon Music",
                "spotify_image": "Imagen de Spotify",
                "deezer_image": "Imagen de Deezer",
                "amazon_music_image": "Imagen de Amazon Music",
                "spotify_id": "ID de Spotify",
                "deezer_id": "ID de Deezer",
                "amazon_music_id": "ID de Amazon Music",
                "apple_id": "ID de Apple",
                "name": "Nombre",
                "name_preference": "Preferencia de Nombre",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Correo Electrónico",
                "subuser": "Sub-Usuario"
            },
            "help_text": {
                "is_new_artist": "¿Estás agregando un nuevo artista? Es decir, si tu artista tiene lanzamientos en Spotify/Deezer/Amazon Music/Apple Music, selecciona No, de lo contrario, selecciona Sí.",
                "spotify_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Spotify, de lo contrario, haz clic en el botón No Encontrado.",
                "deezer_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Deezer, de lo contrario, haz clic en el botón No Encontrado.",
                "amazon_music_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Amazon Music, de lo contrario, haz clic en el botón No Encontrado.",
                "apple_id": "Nota: Solo usa este campo si deseas agregar un artista que ya está en Apple Music, de lo contrario, haz clic en el botón No Encontrado.",
                "subuser": "Nota: Solo usa este desplegable si deseas agregar un artista para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar."
            },
            "placeholder": {
                "subuser": "Seleccionar Sub-usuario...",
                "spotify_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Spotify del Artista, por ejemplo, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Deezer del Artista, por ejemplo, 1406580",
                "amazon_music_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ASIN de Amazon del Artista, por ejemplo, B005GI0T2U",
                "apple_id": "Por favor, ingresa un ID de Apple válido. Ejemplo: 635806095"
            },
            "button": {
                "reset": "Restablecer",
                "not_found": "No Encontrado",
                "submit": "Enviar"
            },
            "option": {
                "yes": "Sí",
                "no": "No"
            },
            "validation": {
                "name_required": "El nombre es obligatorio",
                "name_invalid": "El nombre del artista debe contener 'DJ' solo en mayúsculas",
                "email_required": "El correo electrónico es obligatorio",
                "email_invalid": "Por favor, ingresa un correo electrónico válido",
                "name_duplicate": "El artista ya existe",
                "name_mismatch": "El nombre del artista debe coincidir para todas las tiendas",
                "spotify_id_invalid": "Por favor, agrega un ID de Spotify válido. Ejemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulta nuestro Centro de Ayuda para más información.",
                "apple_id_required": "El ID de Apple es obligatorio",
                "apple_id_invalid": "Por favor, agrega un ID de Apple válido. Ejemplo: 635806095. Consulta nuestro Centro de Ayuda para más información."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Declaración de Nuevo Artista",
                "profile_not_present_declaration": "Declaración de Perfil No Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confirmo que el perfil de este artista no está presente en <strong>{{store}}</strong> y que el perfil de este artista se creará de nuevo en <strong>{{store}}</strong>.",
                "new_artist_declaration": "Confirmo que el perfil de este artista no está presente en ninguna de las siguientes tiendas y que el perfil de este artista se creará de nuevo en estas tiendas.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Confirmar",
                "cancel": "Cancelar"
            }
        },
        "message": {
            "success": "¡El artista ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "errorBlacklisted": "Una o más de las detalles que has proporcionado están relacionadas con un artista que está en la lista negra. Si estás seguro de que el artista no está en la lista negra, por favor contacta al equipo de soporte para más información."
        }
    },
    "update": {
        "title": "Editar Artista",
        "form": {
            "label": {
                "spotify_profile": "Perfil de Spotify",
                "deezer_profile": "Perfil de Deezer",
                "amazon_music_profile": "Perfil de Amazon Music",
                "spotify_image": "Imagen de Spotify",
                "deezer_image": "Imagen de Deezer",
                "amazon_music_image": "Imagen de Amazon Music",
                "spotify_id": "ID de Spotify",
                "deezer_id": "ID de Deezer",
                "amazon_music_id": "ID de Amazon Music",
                "apple_id": "ID de Apple",
                "name": "Nombre",
                "name_preference": "Preferencia de Nombre",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Correo Electrónico",
                "flagged": "Marcado"
            },
            "help_text": {
                "spotify_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Spotify, de lo contrario, haz clic en el botón No Encontrado.",
                "deezer_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Deezer, de lo contrario, haz clic en el botón No Encontrado.",
                "amazon_music_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Amazon Music, de lo contrario, haz clic en el botón No Encontrado.",
                "apple_id": "Nota: Solo usa este campo si deseas agregar un artista que ya está en Apple Music, de lo contrario, haz clic en el botón No Encontrado."
            },
            "placeholder": {
                "spotify_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Spotify del Artista, por ejemplo, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Deezer del Artista, por ejemplo, 1406580",
                "amazon_music_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ASIN de Amazon del Artista, por ejemplo, B005GI0T2U",
                "apple_id": "Por favor, ingresa un ID de Apple válido. Ejemplo: 635806095"
            },
            "button": {
                "reset": "Restablecer",
                "not_found": "No Encontrado",
                "submit": "Enviar"
            },
            "validation": {
                "name_required": "El nombre es obligatorio",
                "email_required": "El correo electrónico es obligatorio",
                "email_invalid": "Por favor, ingresa un correo electrónico válido",
                "name_duplicate": "El artista ya existe",
                "name_mismatch": "El nombre del artista debe coincidir para todas las tiendas",
                "name_mismatch_spotify": "El nombre del perfil de Spotify debe coincidir con el nombre del artista",
                "name_mismatch_deezer": "El nombre del perfil de Deezer debe coincidir con el nombre del artista",
                "name_mismatch_amazon_music": "El nombre del perfil de Amazon debe coincidir con el nombre del artista",
                "spotify_id_invalid": "Por favor, agrega un ID de Spotify válido. Ejemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulta nuestro Centro de Ayuda para más información.",
                "apple_id_required": "El ID de Apple es obligatorio",
                "apple_id_invalid": "Por favor, agrega un ID de Apple válido. Ejemplo: 635806095. Consulta nuestro Centro de Ayuda para más información."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Declaración de Restablecimiento de Perfil",
                "profile_not_present_declaration": "Declaración de Perfil No Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confirmo que el perfil de este artista no está presente en <strong>{{store}}</strong> y que el perfil de este artista se creará de nuevo en <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Soy consciente de que al restablecer el perfil de <strong>{{store}}</strong> de este artista se eliminará el <strong>ID de {{store}}</strong> de todo el sistema y al hacerlo, es probable que cause interrupciones en las tiendas y que los artistas no coincidan."
            },
            "button": {
                "confirm": "Confirmar",
                "cancel": "Cancelar"
            }
        },
        "message": {
            "success": "¡El artista de nombre '{{artistName}}' ha sido actualizado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "errorBlacklisted": "Una o más de las detalles que has proporcionado están relacionadas con un artista que está en la lista negra. Si estás seguro de que el artista no está en la lista negra, por favor contacta al equipo de soporte para más información."
        }
    },
    "add_from_wishlist": {
        "title": "Agregar Artista",
        "form": {
            "label": {
                "spotify_profile": "Perfil de Spotify",
                "deezer_profile": "Perfil de Deezer",
                "amazon_music_profile": "Perfil de Amazon Music",
                "spotify_id": "ID de Spotify",
                "spotify_image": "Imagen de Spotify",
                "deezer_id": "ID de Deezer",
                "deezer_image": "Imagen de Deezer",
                "amazon_music_id": "ID de Amazon",
                "amazon_music_image": "Imagen de Amazon Music",
                "apple_id": "ID de Apple",
                "apple_image": "Imagen de Apple",
                "name": "Nombre",
                "name_preference": "Preferencia de Nombre",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Correo Electrónico",
                "subuser": "Sub-Usuario"
            },
            "placeholder": {
                "spotify_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Spotify del Artista, por ejemplo, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ID de Deezer del Artista, por ejemplo, 1406580",
                "amazon_music_profile": "Ingresa el Nombre del Artista, por ejemplo, The Weekend o el ASIN de Amazon del Artista, por ejemplo, B005GI0T2U",
                "apple_id": "Por favor, ingresa un ID de Apple válido. Ejemplo: 635806095",
                "subuser": "Seleccionar Sub-usuario..."
            },
            "help_text": {
                "spotify_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Spotify, de lo contrario, haz clic en el botón No Encontrado.",
                "deezer_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Deezer, de lo contrario, haz clic en el botón No Encontrado.",
                "amazon_music_profile": "Nota: Solo usa este desplegable si deseas agregar un artista que ya está en Amazon Music, de lo contrario, haz clic en el botón No Encontrado.",
                "apple_id": "Nota: Solo usa este campo si deseas agregar un artista que ya está en Apple Music, de lo contrario, haz clic en el botón No Encontrado.",
                "subuser": "Nota: Solo usa este desplegable si deseas agregar un artista para cualquiera de tus sub-usuarios, de lo contrario, déjalo sin seleccionar."
            },
            "button": {
                "reset": "Restablecer",
                "notFound": "¿No Encontrado?",
                "submit": "Enviar",
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            },
            "validation": {
                "name_required": "El nombre es obligatorio",
                "email_required": "El correo electrónico es obligatorio",
                "email_invalid": "Por favor, ingresa un correo electrónico válido",
                "spotify_id_invalid": "Por favor, agrega un ID de Spotify válido. Ejemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulta nuestro Centro de Ayuda para más información.",
                "apple_id_required": "El ID de Apple es obligatorio",
                "apple_id_invalid": "Por favor, agrega un ID de Apple válido. Ejemplo: 635806095. Consulta nuestro Centro de Ayuda para más información."
            },
            "message": {
                "errorArtistExists": "El artista ya existe",
                "errorNameMismatch": "El nombre del artista debe coincidir para todas las tiendas",
                "errorSpotifyNameMismatch": "El nombre del perfil de Spotify debe coincidir con el nombre del artista",
                "errorDeezerNameMismatch": "El nombre del perfil de Deezer debe coincidir con el nombre del artista",
                "errorAmazonNameMismatch": "El nombre del perfil de Amazon debe coincidir con el nombre del artista"
            }
        },
        "message": {
            "success": "¡El artista ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "errorBlacklisted": "Una o más de las detalles que has proporcionado están relacionadas con un artista que está en la lista negra. Si estás seguro de que el artista no está en la lista negra, por favor contacta al equipo de soporte para más información."
        },
        "modal": {
            "profileMissing": {
                "header": "Declaración de Perfil No Presente",
                "body": "Confirmo que el perfil de este artista no está presente en <strong>{{storeName}}</strong> y que el perfil de este artista se creará de nuevo en <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "SEGUIDORES",
                "popularity": "POPULARIDAD",
                "genres": "GÉNEROS",
                "flagged": "MARCADO",
                "notAvailable": "No Disponible",
                "notAvailableAbbr": "N/D"
            },
            "similarArtists": {
                "title": "Artistas Similares",
                "table": {
                    "column": {
                        "artist": "Artista",
                        "followers": "Seguidores",
                        "popularity_pct": "Popularidad (%)",
                        "genres": "Géneros",
                        "wishlist": "Lista de Deseos"
                    }
                },
                "label": {
                    "notAvailable": "No Disponible",
                    "notAvailableAbbr": "N/D"
                },
                "message": {
                    "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Agregar Artista {{artistName}} a la Lista de Deseos",
                        "body": "¿Estás seguro de que deseas agregar al artista {{artistName}} a tu lista de deseos?",
                        "message": {
                            "success": "¡Artista agregado a la lista de deseos!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Eliminar Artista {{artistName}} de la Lista de Deseos",
                        "body": "¿Estás seguro de que deseas eliminar al artista {{artistName}} de tu lista de deseos?"
                    }
                }
            },
            "topTracks": {
                "title": "Pistas Principales",
                "table": {
                    "column": {
                        "track": "Pista",
                        "release": "Lanzamiento",
                        "artists": "Artista(s)",
                        "popularity_pct": "Popularidad (%)",
                        "preview": "Vista Previa"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Tu navegador no soporta el elemento de audio."
                }
            }
        }
    }
};

export default artistsES;